import Seo from '@/components/Seo';
import { BRAND_LOGO_URL } from '@/data/servicesData';

const CONTACT_NUMBER = '069 057 9693';
const CONTACT_NUMBER_HREF = 'tel:0690579693';
const WHATSAPP_HREF = 'https://wa.me/27690579693';
const CONTACT_EMAIL = 'services@blackline-cleaning.co.za';

const ContactHero = () => (
  <div className="mb-16">
    <div className="blackline-text-card inline-block max-w-3xl splash-heading-bar" data-testid="contact-hero-card">
      <h1 className="font-oswald text-5xl md:text-7xl font-bold uppercase leading-none text-white mb-6" data-testid="contact-hero-title">
        READY TO FIX<br />YOUR EXTERIOR?
      </h1>
      <p className="font-mono text-base md:text-lg text-zinc-400 max-w-2xl mb-4">
        Stop reacting. Start maintaining.
      </p>
      <div className="border-l-4 border-blackline-accent pl-6 mt-8">
        <p className="font-oswald text-xl md:text-2xl uppercase text-blackline-accent font-bold">
          SERVICING JOHANNESBURG & SANDTON AREAS
        </p>
      </div>
    </div>
  </div>
);

const ContactMethodsHeader = () => (
  <div className="blackline-text-card inline-block splash-heading-bar" data-testid="contact-options-card">
    <h2 className="font-oswald text-3xl md:text-4xl font-bold uppercase text-white mb-8" data-testid="contact-options-title">
      CONTACT US DIRECTLY
    </h2>
    <p className="font-mono text-base text-zinc-400 mb-0">
      We removed all detail-entry forms. Reach us directly below.
    </p>
  </div>
);

const ContactDirectCard = () => (
  <div className="border-2 border-blackline-border p-8 md:p-12 blackline-text-card splash-heading-bar" data-testid="contact-direct-card">
    <div className="mb-8">
      <span className="font-oswald text-5xl font-bold text-blackline-accent">01</span>
      <h3 className="font-oswald text-2xl md:text-3xl font-bold uppercase text-white mt-4 mb-4" data-testid="contact-direct-title">
        SPEAK TO OUR TEAM DIRECTLY
      </h3>
      <p className="font-mono text-base text-zinc-400">
        Call, email or WhatsApp us directly for service bookings and quotes.
      </p>
    </div>

    <div className="space-y-8">
      <div className="border-l-4 border-blackline-accent pl-6">
        <p className="font-mono text-base uppercase text-zinc-600 mb-2">PHONE</p>
        <a
          href={CONTACT_NUMBER_HREF}
          className="font-oswald text-2xl md:text-3xl font-bold text-white hover:text-blackline-accent transition-colors block"
          data-testid="contact-phone-link"
        >
          {CONTACT_NUMBER}
        </a>
        <p className="font-mono text-base text-zinc-500 mt-2">Call us during business hours</p>
      </div>

      <div className="border-l-4 border-blackline-accent pl-6">
        <p className="font-mono text-base uppercase text-zinc-600 mb-2">EMAIL</p>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="font-mono text-lg text-white hover:text-blackline-accent transition-colors break-all block"
          data-testid="contact-email-link"
        >
          {CONTACT_EMAIL}
        </a>
        <p className="font-mono text-base text-zinc-500 mt-2">Email us anytime</p>
      </div>

      <div className="border-l-4 border-blackline-accent pl-6">
        <p className="font-mono text-base uppercase text-zinc-600 mb-2">WHATSAPP</p>
        <a
          href={WHATSAPP_HREF}
          target="_blank"
          rel="noopener noreferrer"
          className="font-oswald text-xl font-bold text-white hover:text-blackline-accent transition-colors block"
          data-testid="contact-whatsapp-link"
        >
          WhatsApp: {CONTACT_NUMBER}
        </a>
        <p className="font-mono text-base text-zinc-500 mt-2">Instant messaging available</p>
      </div>

      <div className="border border-blackline-border p-6 mt-8">
        <p className="font-mono text-base uppercase text-zinc-600 mb-2">SERVICE AREA</p>
        <p className="font-oswald text-lg font-bold text-blackline-accent uppercase">
          JOHANNESBURG & SANDTON
        </p>
        <p className="font-mono text-base text-zinc-400 mt-2">
          We service the surrounding Johannesburg and Sandton areas
        </p>
      </div>
    </div>
  </div>
);

const ContactResponseTime = () => (
  <div className="border-t border-blackline-border pt-12">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="blackline-text-card splash-heading-bar" data-testid="contact-response-time-card">
        <h3 className="font-oswald text-xl md:text-2xl font-bold uppercase text-white mb-4" data-testid="contact-response-time-title">
          RESPONSE TIME
        </h3>
        <p className="font-mono text-base text-zinc-400">
          We typically respond within 24 hours. For urgent inquiries, please call or WhatsApp us directly.
        </p>
      </div>
      <div className="border-l border-blackline-border pl-8">
        <p className="font-mono text-base text-zinc-400">
          <span className="text-blackline-accent">→</span> One company. One contract. Everything handled.
        </p>
        <p className="font-mono text-base text-zinc-400 mt-4">
          <span className="text-blackline-accent">→</span> Professional exterior cleaning specialists serving Johannesburg & Sandton.
        </p>
      </div>
    </div>
  </div>
);

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact | BLACKLINE CLEANING"
        description="Contact BLACKLINE CLEANING for exterior cleaning quotes in Johannesburg & Sandton. Call 069 057 9693 or WhatsApp 069 057 9693."
        canonical="https://www.blackline-cleaning.co.za/contact"
        ogImage={BRAND_LOGO_URL}
      />

      <div className="relative pt-40 md:pt-44 pb-24" data-testid="contact-page">
      {/* concrete-texture removed */}
      
      <div className="max-w-6xl mx-auto px-6 py-24 relative z-10">
        <ContactHero />

        {/* Two Clear Options */}
        <div className="mb-24">
          <ContactMethodsHeader />

          <div className="grid grid-cols-1 gap-8">
            <ContactDirectCard />
          </div>
        </div>

        {/* Response Time */}
        <ContactResponseTime />
      </div>
    </div>
    </>
  );
}